<template>
  <div class="ui-eyebrow">
    <span class="ui-eyebrow__bar" />
    <span class="ui-eyebrow__label"><slot /></span>
  </div>
</template>

<script setup>
</script>

<style scoped>
.ui-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: var(--gap-sm);
}

.ui-eyebrow__bar {
  display: block;
  width: 24px;
  height: 2px;
  border-radius: 2px;
  background: var(--cyan);
}

.ui-eyebrow__label {
  font-family: var(--font-brand);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--cyan);
}
</style>
